/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Preset_Manager_SubInputs */

const en_preset_manager_sub = /** @type {(inputs: Preset_Manager_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage your export presets and settings`)
};

const fr_preset_manager_sub = /** @type {(inputs: Preset_Manager_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gérez vos préréglages et paramètres d’export`)
};

const de_preset_manager_sub = /** @type {(inputs: Preset_Manager_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwalten Sie Ihre Exportvorgaben und -einstellungen`)
};

const it_preset_manager_sub = /** @type {(inputs: Preset_Manager_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestisci i tuoi preset e le impostazioni di esportazione`)
};

const ru_preset_manager_sub = /** @type {(inputs: Preset_Manager_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Управляйте своими настройками и параметрами экспорта.`)
};

const es_preset_manager_sub = /** @type {(inputs: Preset_Manager_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administra tus ajustes y configuraciones preestablecidas de exportación`)
};

const zh_cn2_preset_manager_sub = /** @type {(inputs: Preset_Manager_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理您的导出预设和设置`)
};

const ja_preset_manager_sub = /** @type {(inputs: Preset_Manager_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エクスポートのプリセットと設定を管理する`)
};

const hi_preset_manager_sub = /** @type {(inputs: Preset_Manager_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अपने निर्यात प्रीसेट और सेटिंग्स को प्रबंधित करें`)
};

const pt_pt2_preset_manager_sub = /** @type {(inputs: Preset_Manager_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerencie suas predefinições e configurações de exportação.`)
};

/**
* | output |
* | --- |
* | "Manage your export presets and settings" |
*
* @param {Preset_Manager_SubInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const preset_manager_sub = /** @type {((inputs?: Preset_Manager_SubInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preset_Manager_SubInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_preset_manager_sub(inputs)
	if (locale === "de") return de_preset_manager_sub(inputs)
	if (locale === "it") return it_preset_manager_sub(inputs)
	if (locale === "ru") return ru_preset_manager_sub(inputs)
	if (locale === "es") return es_preset_manager_sub(inputs)
	if (locale === "zh-CN") return zh_cn2_preset_manager_sub(inputs)
	if (locale === "ja") return ja_preset_manager_sub(inputs)
	if (locale === "hi") return hi_preset_manager_sub(inputs)
	if (locale === "pt-PT") return pt_pt2_preset_manager_sub(inputs)
	return en_preset_manager_sub(inputs)
});